import axios from './configAxios';

export const postNewClient = async (adressId, requestData) => {
  return axios.post(`/${adressId}/confirm/`, requestData);
};